module.exports = __webpack_public_path__ + "components/flag/static/square/mm-88ae9a0f7d78ec27d143bab3c4f6b9cf.svg";